<template>
  <div>
    <div v-if="!loading && storage_limit_data" class="row">
      <div class="col-6">
        <h4 style="font-size: 1.25rem;" class="mb-4">
          <i class="flaticon2-download mr-2" />

          Storage Space Used
        </h4>
      </div>
      <div class="col-6 text-right">
        <span>
          <small>Last updated : {{ formatDateTime(storage_limit_data.updated_at) }}</small>
          <button class="btn btn-icon btn-ss btn-sm ml-2" @click="update">
            <i class="flaticon2-refresh" />
          </button>
        </span>
      </div>

      <div class="col-12">
        <div class="progress progress--sm my-3" style="height: 0.75rem;">
          <div :class="progress_classes" role="progressbar"
               :style="progressStyles"
               aria-valuenow="10" aria-valuemin="0"
               aria-valuemax="100" />
        </div>
        <div class="d-flex justify-content-between font-weight-bold">
          <span>
            {{ storageUsedGb }} of {{ storage_limit_data.storage_allocation }} GB
          </span>
          <span>
            {{ storageUsedPercentage }}%
          </span>
        </div>
      </div>
    </div>
    <div v-else-if="loading">
      <loader loading-text="Refreshing Storage Limit Data" />
    </div>
  </div>
</template>

<script>

import Loader from "VuePartials/Loader";
export default {
  components: { Loader },
  props: {
    compact: {
      type: Boolean,
      required: false,
      default: false,
    },
    customer: {
      type: Object,
      required: false,
      default: null,
    },
  },
  data: () => ({
    storage_limit_data: null,
    loading: false,
  }),
  computed: {
    storageUsedPercentage() {
      if (this.storage_limit_data) {
        return parseFloat(this.storage_limit_data.percentage_used).toFixed(2);
      }
      return 0;
    },
    storageUsedGb() {
      if (this.storage_limit_data) {
        return parseFloat(this.storage_limit_data.total_used_gb).toFixed(2);
      }
      return 0;
    },
    progress_classes() {
      const progress_classes = {
        'progress-bar progress-bar-striped': true,
      };
      if (this.storage_limit_data) {
        progress_classes[`bg-${this.storage_limit_data.color}`] = true;
        return progress_classes;
      }

      progress_classes['bg-success'] = true;
      return progress_classes;
    },
    progressStyles() {
      if (this.storage_limit_data) {
        return `width:${this.storageUsedPercentage}%;`;
      }
      return 0;
    },
  },
  mounted() {
    if (typeof window.storage_limit_data !== 'undefined') {
      this.storage_limit_data = window.storage_limit_data;
    }

    if (this.customer) {
      this.storage_limit_data = window.storage_usage[this.customer.slug];
    }
  },
  methods: {
    async update() {
      // Create non-reactive copy of the data.
      const original = JSON.parse(JSON.stringify(this.storage_limit_data));
      this.storage_limit_data = null;
      this.loading = true;
      try {
        const response = await axios.patch(`/api/v1/customer/${original.customer_slug}/storage-usage`);
        this.storage_limit_data = response.data.data;
        this.loading = false;
      } catch (e) {
        this.storage_limit_data = original;
        this.loading = false;
        console.error(e);
        toastr.error("Unable to update storage limit information. Please contact SharpStream Support");
      }
    },
  },
};
</script>
